import { render, staticRenderFns } from "./MarketingCenter.vue?vue&type=template&id=def65338&scoped=true&"
import script from "./MarketingCenter.vue?vue&type=script&lang=js&"
export * from "./MarketingCenter.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCenter.vue?vue&type=style&index=0&id=def65338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def65338",
  null
  
)

export default component.exports